const styles = () => ({
  spinner: {
    animation: 'rotate 1s ease infinite',
    width: '50px',
    height: '50px',
  },

  ring: {
    fill: 'none',
    stroke: '#F0F4F8',
    animation: 'ring 1s ease-out infinite',
  },

  segment: {
    stroke: '#637EFF',
    fill: 'none',
    strokeLinecap: 'round',
    strokeDashoffset: 43,
    strokeDasharray: '25, 100',
    animation: 'segment 1s ease-out infinite',
  },

  '@keyframes rotate': {
    '0%': {
      transform: 'rotate(0deg)',
    },

    '50%': {},

    '100%': {
      transform: 'rotate(360deg)',
    },
  },

  '@keyframes segment': {
    '0%': {
      stroke: '#637EFF',
    },

    '50%': {
      stroke: '#C363E5',
      strokeWidth: '8px',
    },

    '100%': {
      stroke: '#637EFF',
    },
  },

  '@keyframes ring': {
    '0%': {},

    '50%': {
      strokeWidth: '6px',
    },

    '100%': {},
  },
});

const Spinner = ({ classes, className }) => {
  return (
    <svg className={classnames(classes.spinner, className)} viewBox="0 0 50 50">
      <circle
        className={classes.ring}
        cx="25"
        cy="25"
        r="20"
        strokeWidth="5"></circle>
      <circle
        className={classes.segment}
        cx="25"
        cy="25"
        r="20"
        strokeWidth="5"></circle>
    </svg>
  );
};

export default withStyles(styles)(Spinner);
